import React, { Component } from 'react';
import {Row, Col} from  'react-bootstrap';
import Modal from '../lib/modal-shim';

export class ModalDriverPanel extends Component {

  render() {
    return (
      <Modal show={this.props.showPanel} onHide={this.props.onClose}>
        <Modal.Header closeButton className="chat-modal-header">
          <Modal.Title>Driver Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
                <Row>
                <Col lg={12} md={12} sm={12} xs={12} >
                  <div className="profile-image">
                      <img src={this.props.data ? this.props.data.image : ''} className="img-circle circle-border m-b-md" alt="profile" />
                  </div>
                  <div className="profile-info">
                      <div>
                          <div>
                              <h2 className="no-margins">
                                  {this.props.data ? this.props.data.pilotName : ''}
                              </h2>
                              <h4>Driver n. 111111</h4>
                              <small>
                                  Simple description or more driver info
                              </small>
                          </div>
                      </div>
                  </div>
                  <div className="clearfix" />
                </Col>

                <Col lg={6} md={6} sm={6} xs={6} >
                <dl className="dl-horizontal">
                    <dt>Name:</dt> <dd>{this.props.data ? this.props.data.pilotName : ''}</dd>
                    <dt>License n.:</dt> <dd>12345678 </dd>
                    <dt>License date:</dt> <dd>01/01/2000</dd>
                </dl>
                </Col>

                <Col lg={6} md={6} sm={6} xs={6} >
                <dl className="dl-horizontal">
                    <dt>Special license:</dt> <dd>hazardous material</dd>
                    <dt>Truck n. :</dt> <dd>22222</dd>
                </dl>
                </Col>

                <Col lg={12} md={12} sm={12} xs={12} >
                  <img src="img/driver-license.jpg" className="img-responsive" alt="license" />
                </Col>

                  <Col lg={12} md={12} sm={12} xs={12} >
                  <div className="file-manager">
                    <h5>File attached</h5>

                    <ul className="folder-list" >
                        <li><a href=""><i className="fa fa-file-pdf-o"></i> Driver license</a></li>
                        <li><a href=""><i className="fa fa-file-word-o"></i> Cargo documentation</a></li>
                        <li><a href=""><i className="fa fa-file-pdf-o"></i> Hazardous special license</a></li>
                        <li><a href=""><i className="fa fa-file-pdf-o"></i> Shipment Receipt</a></li>
                        <li><a href=""><i className="fa fa-file-word-o"></i> File</a></li>
                        <li><a href=""><i className="fa fa-file-pdf-o"></i> File</a></li>
                    </ul>

                    <div className="clearfix"></div>
                </div>
                </Col>


                </Row>


        </Modal.Body>
      </Modal>
    )
  }

}



// WEBPACK FOOTER //
// ./src/components/ModalDriverPanel.js